/*
 * @Name: index/api
 * @Description: 首页相关api
 * @Author: xiadongxue
 * @Date: 2021-10-21 10:14:35
 * @Editors: xiadongxue
 */
import { jsonPost } from '@/assets/js/axios';
import axios from 'axios';

//首页
//系统入口
const getProjectList = () => jsonPost('/server/home/getAvailProjectList')

//审核
const audit = '/server/audit/pipline'
//待办列表
const backlog = (params) => axios.get(`${audit}/list/backlog`,{ params })
//权限申请
const auditSet = (params) => jsonPost(`${audit}/set`, params)
//申请列表
const applyList = (params) => axios.get(`${audit}/list/apply`,{ params })
//工单撤销
const applyRevoke = (params) => axios.post(`${audit}/revoke`, params)
//审核进度
const applyFlow = (params) => axios.get(`${audit}/flow`,{ params })
//审核列表
const approvalList = (params) => axios.get(`${audit}/list/audit`,{ params })
//审核
const auditAction = (params) => jsonPost(`${audit}/audit/action`, params)
//批量审核
const auditBatchAction = (params) => jsonPost(`${audit}/audit/action/batch`, params)
//工单列表
const auditAll = (params) => axios.get(`${audit}/list/all`,{ params })
//一键审批
const oneAudit = (params) => axios.post(`${audit}/one/click/audit/action`, params)

export {
    getProjectList,
    backlog,
    auditSet,
    applyList,
    applyRevoke,
    applyFlow,
    approvalList,
    auditAction,
    auditBatchAction,
    auditAll,
    oneAudit
}
